module.exports = {
	"title": "Articles ",
	"pageTitle": "Articles",
	"link": "articles",
	"sections": [
		{
			"sectionTitle": "About Claire Messud",
			"enableSort": true,
			"articles": [
				{
					"articleTitle": "Who’s Afraid of Claire Messud?",
					"publisher": "New York Times Magazine",
					"articleDate": "08/10/2017",
					"link": "https://www.nytimes.com/2017/08/10/magazine/whos-afraid-of-claire-messud.html"
				},
				{
					"articleTitle": "Claire Messud’s ‘The Burning Girl’ takes on a fraught friendship with splendorous prose",
					"publisher": "Los Angeles Times",
					"articleDate": "08/24/2017",
					"link": "http://www.latimes.com/books/jacketcopy/la-ca-jc-carroll-burning-girl-20170824-story.html"
				},
				{
					"articleTitle": "Shaping Stories to Make Sense of Ourselves",
					"publisher": "New York Review of Books",
					"articleDate": "09/28/2017",
					"link": "http://www.nybooks.com/articles/2017/09/28/shaping-stories-to-make-sense-of-ourselves/"
				},
				{
					"articleTitle": "Claire Messud sets the world afire — again — with ‘The Burning Girl’",
					"publisher": "Chicago Tribune",
					"articleDate": "08/25/2017",
					"link": "http://www.chicagotribune.com/lifestyles/books/sc-burning-girl-claire-messud-books-0830-20170824-story.html"
				},
				{
					"articleTitle": "Adolescent Friendship Fades Away In Claire Messud's Gothic 'Burning Girl'",
					"publisher": "NPR",
					"articleDate": "09/12/2017",
					"link": "http://www.npr.org/2017/09/12/550394260/adolescent-friendship-fades-away-in-claire-messuds-gothic-burning-girl"
				},
				{
					"articleTitle": "A Friendship Between Two Girls and Its Tragic Unraveling",
					"publisher": "Booklist",
					"articleDate": "07/01/2017",
					"link": "https://www.booklistonline.com/The-Burning-Girl-Claire-Messud/pid=8948888"
				},
				{
					"articleTitle": "'The Burning Girl' by Claire Messud: Innocence and Loss",
					"publisher": "The Guardian",
					"articleDate": "09/09/2017",
					"link": "https://www.theguardian.com/books/2017/sep/09/the-burning-girl-claire-messud-review"
				}
			]
		},
		{
			"sectionTitle": "By Claire Messud",
			"enableSort": false,
			"articles": [
				{
					"articleTitle": "New Books August 2021",
					"publisher": "Harper's ",
					"link": "https://harpers.org/archive/2021/08/new-books-august-2021/",
					"startDate": "07/20/2021"
				},
				{
					"articleTitle": "New Books July 2021",
					"publisher": "Harper's",
					"link": "https://harpers.org/archive/2021/07/new-books-july-2021-spiotta-wayward-mairal-woman-from-urugu-sahota-china-roomay/",
					"startDate": "07/08/2021"
				},
				{
					"articleTitle": "New Books June 2021",
					"publisher": "Harper's ",
					"link": "https://harpers.org/archive/2021/06/new-books-june-2021/",
					"startDate": "07/08/2021"
				},
				{
					"articleTitle": "New Book May 2021",
					"publisher": "Harper's ",
					"link": "https://harpers.org/archive/2021/05/new-books-the-window-seat-forna-on-violence-and-on-violence-against-women-rose-see-saw-dyer/",
					"startDate": "07/08/2021"
				},
				{
					"articleTitle": "New Books April 2021",
					"publisher": "Harper's ",
					"link": "https://harpers.org/archive/2021/04/new-books-april-2021/",
					"startDate": "07/08/2021"
				},
				{
					"articleTitle": "New Books March 2021",
					"publisher": "Harper's",
					"link": "https://harpers.org/archive/2021/03/who-will-pay-reparations-on-my-soul-places-of-mind-edward-said-twilight-zone/",
					"startDate": "07/08/2021"
				},
				{
					"articleTitle": "New Books February 2021",
					"publisher": "Harper's",
					"link": "https://harpers.org/archive/2021/03/who-will-pay-reparations-on-my-soul-places-of-mind-edward-said-twilight-zone/",
					"startDate": "07/08/2021"
				},
				{
					"articleTitle": "New Books January 2021",
					"link": "https://harpers.org/archive/2021/03/who-will-pay-reparations-on-my-soul-places-of-mind-edward-said-twilight-zone/",
					"startDate": "07/08/2021"
				}
			]
		}
	],
	"_doc": "b16c24cf6201a85a5cb9",
	"attachments": {},
	"_system": {
		"deleted": false,
		"changeset": "516:c85996748f8918d5d53e",
		"created_on": {
			"timestamp": "16-May-2017 16:38:38",
			"year": 2017,
			"month": 4,
			"day_of_month": 16,
			"hour": 16,
			"minute": 38,
			"second": 38,
			"millisecond": 557,
			"ms": 1494952718557,
			"iso_8601": "2017-05-16T16:38:38Z"
		},
		"created_by": "mmcginnis",
		"created_by_principal_id": "7683d13972fe921163df",
		"created_by_principal_domain_id": "3d96ab762d6c9248425b",
		"modified_on": {
			"timestamp": "20-Jul-2021 13:36:52",
			"year": 2021,
			"month": 6,
			"day_of_month": 20,
			"hour": 13,
			"minute": 36,
			"second": 52,
			"millisecond": 720,
			"ms": 1626788212720,
			"iso_8601": "2021-07-20T13:36:52Z"
		},
		"modified_by": "mmcginnis",
		"modified_by_principal_id": "7683d13972fe921163df",
		"modified_by_principal_domain_id": "3d96ab762d6c9248425b",
		"previousChangeset": "512:8d7b0458fc6d849804ee",
		"edited_on": {
			"timestamp": "20-Jul-2021 13:36:52",
			"year": 2021,
			"month": 6,
			"day_of_month": 20,
			"hour": 13,
			"minute": 36,
			"second": 52,
			"millisecond": 720,
			"ms": 1626788212720,
			"iso_8601": "2021-07-20T13:36:52Z"
		},
		"edited_by": "mmcginnis",
		"edited_by_principal_id": "7683d13972fe921163df",
		"edited_by_principal_domain_id": "3d96ab762d6c9248425b",
		"rev": 516
	},
	"_statistics": {
		"a:child": 1,
		"a:child_INCOMING": 1,
		"a:has_role": 4,
		"a:has_role_INCOMING": 4,
		"a:linked": 1,
		"a:linked_INCOMING": 1
	},
	"insightNode": "99f505c98cb37175bbe5/7df865401a95482cf6ba/b16c24cf6201a85a5cb9",
	"status": "OK"
};


//////////////////
// WEBPACK FOOTER
// ./src/jsondata/articles.json
// module id = 504
// module chunks = 0